import axios from 'axios';
import { createBrowserHistory } from 'history';

export const handleError = (err: any) => {
  const history = createBrowserHistory();

  if (axios.isAxiosError(err) && err.response?.status === 401) {
      alert('권한이 없습니다. 다시 로그인해주세요.');
      window.location.href = "/login";
  } else {
    alert('내부 에러가 발생했습니다. 전산팀에 문의하세요.');
  }
}
